"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactErrorBoundary = _interopRequireDefault(require("react-error-boundary"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _Dialog = _interopRequireDefault(require("@eig-builder/core-ui/Dialog"));

var _Grow = _interopRequireDefault(require("@eig-builder/core-ui/Grow"));

var _styles = require("@eig-builder/core-ui/styles");

var _compositionsError = _interopRequireDefault(require("@eig-builder/compositions-error"));

var _modalHeader = _interopRequireDefault(require("./modal-header"));

var _modalTabs = _interopRequireDefault(require("./modal-tabs"));

var _modalContent = _interopRequireDefault(require("./modal-content"));

var _modalFooter = _interopRequireDefault(require("./modal-footer"));

var _alignment = _interopRequireDefault(require("./alignment"));

var _modalContext = _interopRequireDefault(require("./modal-context"));

// Helpers.
// Core UI
// Components.
// Context
var useStyles = (0, _styles.makeStyles)({
  paper: {
    height: function height(props) {
      return !props.fullScreen ? props.height : '';
    },
    overflow: 'hidden',
    transform: 'translate3d(0, 0, 0)' // Create new context so position fixed will target the context of the modal.

  }
});

var Transition = _react["default"].forwardRef(function Transition(props, ref) {
  return _react["default"].createElement(_Grow["default"], (0, _extends2["default"])({
    ref: ref
  }, props));
});

var Modal = function Modal(props) {
  var classes = useStyles({
    height: props.height,
    fullScreen: props.fullScreen
  });
  var headerRef = (0, _react.useRef)();
  var tabsRef = (0, _react.useRef)();

  if (!props.dataElementPrefix && process.env.NODE_ENV !== 'production') {
    console.warn('No dataElementPrefix prop is provided to the modal, please provide a dataElementPrefix prop for proper Analytics tracking!');
  }

  return _react["default"].createElement(_modalContext["default"].Provider, {
    value: {
      tabsRef: tabsRef,
      headerRef: headerRef,
      onClose: props.onClose,
      variant: props.variant,
      processing: props.processing,
      bodyScroll: props.scroll === 'body',
      dataElementPrefix: props.dataElementPrefix
    }
  }, _react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({}, (0, _omit["default"])(props, 'children', 'processing', 'dataElementPrefix'), {
    TransitionComponent: Transition,
    disableBackdropClick: props.disableBackdropClick || !!props.processing,
    disableEscapeKeyDown: !!props.processing,
    classes: classes
  }), _react["default"].createElement(_reactErrorBoundary["default"], {
    FallbackComponent: function FallbackComponent() {
      return _react["default"].createElement(_compositionsError["default"], {
        onClick: props.onClose
      });
    }
  }, props.children)));
}; // Compounds.


Modal.Header = _modalHeader["default"];
Modal.Tabs = _modalTabs["default"];
Modal.Content = _modalContent["default"];
Modal.Footer = _modalFooter["default"];
Modal.Alignment = _alignment["default"]; // Define propTypes.

Modal.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  onClose: _propTypes["default"].func.isRequired,
  fullWidth: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  variant: _propTypes["default"].oneOf(['default', 'transparent', 'light']),
  height: _propTypes["default"].string,
  scroll: _propTypes["default"].oneOf(['body', 'paper']),
  fullScreen: _propTypes["default"].bool,
  dataElementPrefix: _propTypes["default"].string,
  processing: _propTypes["default"].bool,
  disableBackdropClick: _propTypes["default"].bool
};
Modal.defaultProps = {
  fullWidth: true,
  fullScreen: false,
  maxWidth: 'xs',
  height: 'auto',
  scroll: 'paper',
  variant: 'default',
  processing: false
};
var _default = Modal;
exports["default"] = _default;